var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "upload" }, [
        _c("h1", {
          staticClass: "upload__header",
          domProps: {
            innerHTML: _vm._s(
              _vm.mergeHtmlContent(
                this.config.lang["account.upload.header"],
                " ",
                this.config.tooltip["account.upload.headerhelp"]
              )
            )
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "upload__table dropzone-settings" }, [
          _c("div", { staticClass: "upload__section" }, [
            _c("h2", {
              staticClass: "upload__section_header",
              domProps: {
                innerHTML: _vm._s(
                  _vm.mergeHtmlContent(
                    this.config.lang["account.upload.uploadname-einzelbrief"],
                    " ",
                    this.config.tooltip["account.upload.uploadhelp-einzelbrief"]
                  )
                )
              }
            }),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "singlefileform",
                staticClass:
                  "upload__section_download upload__section_download--einzelbrief",
                attrs: { "data-jobtype": this.config.types.single.jobType }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "upload__section_clickable upload__section_clickable--single",
                    on: {
                      click: function($event) {
                        return _vm.$refs.singlefile.click()
                      }
                    }
                  },
                  [
                    _c("transition", { attrs: { name: "modalfade" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isSingleProgressBarVisible,
                              expression: "!isSingleProgressBarVisible"
                            }
                          ]
                        },
                        [
                          _c("p", {
                            staticClass: "upload__section_action",
                            domProps: {
                              innerHTML: _vm._s(
                                this.config.lang["account.upload.action"]
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "upload__section_label",
                            domProps: {
                              innerHTML: _vm._s(
                                this.config.lang[
                                  "account.upload.uploadname-einzelbrief"
                                ]
                              )
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "modalfade" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isSingleProgressBarVisible,
                              expression: "isSingleProgressBarVisible"
                            }
                          ],
                          staticClass: "progress-bar__wrapper"
                        },
                        [
                          _c("div", { staticClass: "progress-bar__upload" }, [
                            _c(
                              "div",
                              {
                                ref: "singleProgressBar",
                                staticClass: "progress-bar__upload-progress",
                                attrs: { role: "progressbar" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    ref: "singleProgressBarText",
                                    staticClass: "progress-text"
                                  },
                                  [_vm._v(" ")]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      ref: "singlefile",
                      staticClass: "display--none",
                      attrs: {
                        type: "file",
                        accept: this.config.settings[
                          "ebrief.upload.accepted_types"
                        ],
                        "data-jobtype": this.config.types.single.jobType,
                        multiple: ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "dz-message dz-error" })
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "upload__section_formatinfo" }, [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    this.config.lang["account.upload.formatinfo-section.text"]
                  )
                }
              }),
              _vm._v(" "),
              _c("a", {
                attrs: {
                  href: this.config.routes["ebrief_account_help_submittals"]
                },
                domProps: {
                  innerHTML: _vm._s(
                    this.config.lang["account.upload.formatinfo-section.link"]
                  )
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "upload__section" }, [
            _c("h2", {
              staticClass: "upload__section_header",
              domProps: {
                innerHTML: _vm._s(
                  _vm.mergeHtmlContent(
                    this.config.lang["account.upload.uploadname-serienbrief"],
                    " ",
                    " "
                  )
                )
              }
            }),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "bulkfileform",
                staticClass:
                  "upload__section_download upload__section_download--serienbrief",
                attrs: { "data-jobtype": this.config.types.bulk.jobType }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "upload__section_clickable upload__section_clickable--bulk",
                    on: {
                      click: function($event) {
                        return _vm.$refs.bulkfile.click()
                      }
                    }
                  },
                  [
                    _c("transition", { attrs: { name: "modalfade" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isBulkProgressBarVisible,
                              expression: "!isBulkProgressBarVisible"
                            }
                          ]
                        },
                        [
                          _c("p", {
                            staticClass: "upload__section_action",
                            domProps: {
                              innerHTML: _vm._s(
                                this.config.lang["account.upload.action"]
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "upload__section_label",
                            domProps: {
                              innerHTML: _vm._s(
                                this.config.lang[
                                  "account.upload.uploadname-serienbrief"
                                ]
                              )
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "modalfade" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isBulkProgressBarVisible,
                              expression: "isBulkProgressBarVisible"
                            }
                          ],
                          staticClass: "progress-bar__wrapper"
                        },
                        [
                          _c("div", { staticClass: "progress-bar__upload" }, [
                            _c(
                              "div",
                              {
                                ref: "bulkProgressBar",
                                staticClass: "progress-bar__upload-progress",
                                attrs: { role: "progressbar" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    ref: "bulkProgressBarText",
                                    staticClass: "progress-text"
                                  },
                                  [_vm._v(" ")]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      ref: "bulkfile",
                      staticClass: "display--none",
                      attrs: {
                        type: "file",
                        accept: this.config.settings[
                          "ebrief.upload.accepted_types"
                        ],
                        "data-jobtype": this.config.types.bulk.jobType,
                        multiple: ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "dz-message" })
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "upload__section_formatinfo" }, [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    this.config.lang["account.upload.formatinfo-section.text"]
                  )
                }
              }),
              _vm._v(" "),
              _c("a", {
                attrs: {
                  href: this.config.routes["ebrief_account_help_submittals"]
                },
                domProps: {
                  innerHTML: _vm._s(
                    this.config.lang["account.upload.formatinfo-section.link"]
                  )
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "upload__formatinfo_mobile" }, [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                this.config.lang["account.upload.formatinfo-section.text"]
              )
            }
          }),
          _vm._v(" "),
          _c("a", {
            attrs: {
              href: this.config.routes["ebrief_account_help_submittals"]
            },
            domProps: {
              innerHTML: _vm._s(
                this.config.lang["account.upload.formatinfo-section.link"]
              )
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modalfade" } },
        [
          _c("SingleLetterControl", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isSingleLetterControlVisible,
                expression: "isSingleLetterControlVisible"
              }
            ],
            attrs: {
              configdata: _vm.configdata,
              jobcount: _vm.jobcount,
              filelist: this.files,
              attachmentlist: this.attachments
            },
            on: {
              "update-files": _vm.updateFiles,
              "update-attachments": _vm.updateAttachments,
              "submit-upload": _vm.submitUpload,
              "close-single-modal": _vm.closeSingleModal,
              "open-error-modal": _vm.openErrorModal
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modalfade" } },
        [
          _c("BulkLetterControl", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isBulkLetterControlVisible,
                expression: "isBulkLetterControlVisible"
              }
            ],
            attrs: {
              configdata: _vm.configdata,
              jobcount: _vm.jobcount,
              filelist: this.files,
              attachmentlist: this.attachments
            },
            on: {
              "update-files": _vm.updateFiles,
              "update-attachments": _vm.updateAttachments,
              "submit-upload": _vm.submitUpload,
              "close-bulk-modal": _vm.closeBulkModal,
              "open-error-modal": _vm.openErrorModal
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "modalfade" } },
        [
          _c("UploadErrorModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isErrorModalVisible,
                expression: "isErrorModalVisible"
              }
            ],
            attrs: { configdata: _vm.configdata, errordata: _vm.errordata },
            on: { "close-error-modal": _vm.closeErrorModal }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }